import React from 'react';
import ddt from '@wix/da-ddt';
import { ViewerContainerSizeContext } from './ViewerContainerSizeContext';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
const MeasuredViewerContainerSizeContextProvider = ({ children, cookieType, cookieDim, innerPadding = 0, className })=>{
    const { ref, dimensions: containerSize } = useMeasureElementCookie(cookieType, {
        cookieDim
    });
    const width = containerSize ? containerSize.width - innerPadding : undefined;
    ddt.log('measuredhook', 'MeasuredViewerContainerSizeContextProvider', {
        width,
        containerSize,
        innerPadding
    });
    return /*#__PURE__*/ React.createElement(ViewerContainerSizeContext.Provider, {
        value: width
    }, /*#__PURE__*/ React.createElement("div", {
        className: className,
        ref: ref
    }, children));
};
MeasuredViewerContainerSizeContextProvider.displayName = 'MeasuredViewerContainerSizeContextProvider';
export default MeasuredViewerContainerSizeContextProvider;

//# sourceMappingURL=MeasuredViewerContainerSizeContextProvider.js.map